import { z } from "zod"

export const QRParamsSchema = z.object({
  identifier: z.string(),
})
